var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNrcsusdagov(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1653,
    height: 992,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1653,
    height: 992
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1142,
    y: 252,
    width: 1424,
    height: 496
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1142,
    y: 252,
    width: 1424,
    height: 496
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 82,
    width: 1650,
    height: 990
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1032 -82)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1033,
    y: 82.9998,
    width: 1650,
    height: 989,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 683.523 2562.5 683.523M1142.5 622.521 2562.5 622.521M1142.5 560.519 2562.5 560.519M1142.5 498.517 2562.5 498.517M1142.5 437.515 2562.5 437.515M1142.5 375.513 2562.5 375.513M1142.5 314.51 2562.5 314.51M1142.5 252.5 2562.5 252.5",
    stroke: "#D9D9D9",
    strokeWidth: 3.4375,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1183.04 667.022 1220.04 667.022 1220.04 745 1183.04 745ZM1302.04 627.021 1339.04 627.021 1339.04 745 1302.04 745ZM1420.05 553.018 1457.05 553.018 1457.05 745 1420.05 745ZM1538.05 459.015 1575.05 459.015 1575.05 745 1538.05 745ZM1657.05 385.013 1694.06 385.013 1694.06 745 1657.05 745ZM1775.06 326.011 1812.06 326.011 1812.06 745 1775.06 745ZM1893.06 291.01 1930.06 291.01 1930.06 745 1893.06 745ZM2012.07 306.01 2049.07 306.01 2049.07 745 2012.07 745ZM2130.07 368.012 2167.07 368.012 2167.07 745 2130.07 745ZM2248.07 444.015 2285.07 444.015 2285.07 745 2248.07 745ZM2367.08 547.018 2404.08 547.018 2404.08 745 2367.08 745ZM2485.08 638.021 2522.08 638.021 2522.08 745 2485.08 745Z",
    fill: "#4472C4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 745.5 2562.5 745.5",
    stroke: "#D9D9D9",
    strokeWidth: 3.4375,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1202 679.022 1320.04 671.022 1439.05 570.019 1557.05 498.016 1675.05 411.013 1794.06 305 1912.06 389.013 2030.07 478.016 2149.07 511.017 2267.07 550.018 2385.08 644.021 2504 682",
    stroke: "#ED7D31",
    strokeWidth: 10.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 757)"
  }, "0")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 702)"
  }, "0.5")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 647)"
  }, "1")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 593)"
  }, "1.5")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 538)"
  }, "2")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 483)"
  }, "2.5")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 428)"
  }, "3")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 374)"
  }, "3.5")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 319)"
  }, "4")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2600.97 264)"
  }, "4.5")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1083.66 757)"
  }, "0")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 695)"
  }, "10")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 634)"
  }, "20")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 572)"
  }, "30")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 510)"
  }, "40")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 449)"
  }, "50")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 387)"
  }, "60")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 326)"
  }, "70")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1062.76 264)"
  }, "80")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1120.49 890)"
  }, "January")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1223.98 905)"
  }, "February")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1371.67 876)"
  }, "March")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1510.96 855)"
  }, "April")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1632.94 851)"
  }, "May")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1748.9 853)"
  }, "June")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1877.17 844)"
  }, "July")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 1957.58 881)"
  }, "August")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 2027.48 930)"
  }, "September")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 2179.85 896)"
  }, "October")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 2269.77 924)"
  }, "November")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 2390.68 922)"
  }, "December")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 64,
    transform: "matrix(1 0 0 1 1525.65 178)"
  }, "Whitewood Township, SD")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1459,
    y: 995,
    width: 88,
    height: 22.9997,
    fill: "#4472C4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1556.66 1018)"
  }, "Temperature (F\xB0)")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1909 1006 1997 1006",
    stroke: "#ED7D31",
    strokeWidth: 10.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2005.94 1018)"
  }, "Rainfall (Inches)")), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 83.5,
    width: 1650,
    height: 989,
    stroke: "#D9D9D9",
    strokeWidth: 3.4375,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrcsusdagov);
export default __webpack_public_path__ + "static/media/nrcs.usda.gov.a1368236440bff0e845bb806cca2484b.svg";
export { ForwardRef as ReactComponent };